var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/address-form/country.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
output += "\n\n";
output += "\n\n<div class=\"c-form__field is-required\">\n\n    <label for=\"account-address-country-select\" class=\"c-form__label\">\n\n        ";
output += runtime.suppressValue((lineno = 19, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-globalFormField-selectCountry",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n    </label>\n\n    <select name=\"address.country\" id=\"account-address-country-select\" class=\"js-address-form-item js-account-address-country-select c-form__select\" data-address-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"id"), env.opts.autoescape);
output += "\" required aria-required=\"true\" data-cm-element='country' data-qa-address-form-country-select aria-describedby=\"address.country_error\">\n\n        <option value=\"\" disabled hidden>\n\n            ";
output += runtime.suppressValue((lineno = 27, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-globalFormField-selectCountry",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n        </option>";
var t_1;
t_1 = (lineno = 31, colno = 48, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "helpers")),"getSiteBySiteId"), "helpers[\"getSiteBySiteId\"]", context, [runtime.contextOrFrameLookup(context, frame, "state")]));
frame.set("siteIndex", t_1, true);
if(frame.topLevel) {
context.setVariable("siteIndex", t_1);
}
if(frame.topLevel) {
context.addExport("siteIndex", t_1);
}
frame = frame.push();
var t_4 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")),"siteConfig")),"allCountries");
if(t_4) {var t_3 = t_4.length;
for(var t_2=0; t_2 < t_4.length; t_2++) {
var t_5 = t_4[t_2];
frame.set("country", t_5);
frame.set("loop.index", t_2 + 1);
frame.set("loop.index0", t_2);
frame.set("loop.revindex", t_3 - t_2);
frame.set("loop.revindex0", t_3 - t_2 - 1);
frame.set("loop.first", t_2 === 0);
frame.set("loop.last", t_2 === t_3 - 1);
frame.set("loop.length", t_3);
output += "\n\n            ";
if((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress"))) {
output += "\n\n                ";
if((runtime.memberLookup((runtime.memberLookup(((lineno = 37, colno = 32, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"country") == runtime.memberLookup((t_5),"countryCode"))) {
output += "\n\n                    <option selected value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"countryCode"), env.opts.autoescape);
output += "\" >\n\n                        ";
output += runtime.suppressValue(runtime.memberLookup((t_5),"name"), env.opts.autoescape);
output += "\n\n                    </option>\n\n                ";
;
}
else {
output += "\n\n                    <option value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"countryCode"), env.opts.autoescape);
output += "\" >\n\n                        ";
output += runtime.suppressValue(runtime.memberLookup((t_5),"name"), env.opts.autoescape);
output += "\n\n                    </option>\n\n                ";
;
}
output += "\n\n            ";
;
}
else {
if((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")),"userLocation")),"country_code") == "US" && runtime.memberLookup((t_5),"countryCode") == "US") || (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")),"userLocation")),"country_code") == "CA" && runtime.memberLookup((t_5),"countryCode") == "CA") || (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")),"userLocation")),"country_code") == "GB" && runtime.memberLookup((t_5),"countryCode") == "GB") || (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")),"userLocation")),"country_code") == "DE" && runtime.memberLookup((t_5),"countryCode") == "DE") || (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")),"userLocation")),"country_code") == "FR" && runtime.memberLookup((t_5),"countryCode") == "FR")) {
output += "\n\n                <option selected value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"countryCode"), env.opts.autoescape);
output += "\" >\n\n                    ";
output += runtime.suppressValue(runtime.memberLookup((t_5),"name"), env.opts.autoescape);
output += "\n\n                </option>\n\n            ";
;
}
else {
output += "\n\n                <option data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_5),"countryCode"), env.opts.autoescape);
output += "\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")),"userLocation")),"country_code") == runtime.memberLookup((t_5),"countryCode")) {
output += " selected ";
;
}
output += " >\n                    ";
output += runtime.suppressValue(runtime.memberLookup((t_5),"name"), env.opts.autoescape);
output += "\n                </option>\n\n            ";
;
}
;
}
output += "\n\n        ";
;
}
}
frame = frame.pop();
output += "\n\n    </select>\n\n    <span class=\"c-form-message\" data-qa-error-field=\"country\" id=\"address.country_error\">\n\n        ";
output += runtime.suppressValue((lineno = 81, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_validations-country",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n    </span>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/address-form/country.j2"] , dependencies)